import { OfferingsLoaded, OfferingUpdated} from "./offerings.actions";
import { Offering } from "./offering";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";



export class OfferingsReducer extends ReducerBase<Offering[]> {
  constructor() {
    super();
    this.addHandler(OfferingsLoaded.EventName, this.handleOfferingsLoaded);
    this.addHandler(OfferingUpdated.EventName, this.handleOfferingUpdated);
  }

  handleOfferingsLoaded(
    state: Offering[] = initialState.offerings
    , event: OfferingsLoaded): Offering[] {
    return event.offerings;
  }

  handleDefault(state: Offering[] = initialState.offerings) {
    return state;
  }

  handleOfferingUpdated(
    state: Offering[] = initialState.offerings,
    event: OfferingUpdated
  ): Offering[] {
    return state.map(f => (f.location.id === event.offering.location.id && 
      f.commodity.id === event.offering.commodity.id ? event.offering : f));
  }

}


